import React, { useState } from "react";
import Head from "next/head";
import Image from "next/image";
import { Grid, Stack, StepContent } from "@mui/material";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import StepLabel from "@mui/material/StepLabel";
import Link from "next/link";
import CareerCard from "../../components/Careers/CareerCard";
import WorkingWithUs from "../../components/Careers/WorkingWithUs";
import Expertise from "../../components/Careers/Expertise";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AbsoluteSkewebar from "@/components/Common/AbsoluteSkewebar";
import ContactUs from "../contact-elchemy";
import MetaTags from "@/components/seo/meta-tags";
import { BreadcrumbJsonLd } from "next-seo";
import { JOB_LISTING_LINK, S3_BASE_URL } from "@/constastants/Constant";
import { getCDNImageUrl } from "@/utils/Common";

const contact = "hr@elchemy.com or Contact Us";
const contentimage = [
  {
    id: "1",
    imgsSrc:
      `${S3_BASE_URL}/entrepreneurs-new.webp`,
    heading: "Multigenerational team",
    description:
      "Elchemy is like a family where seasoned industry pros and young  enthusiastic chemical engineers come together. We're a diverse bunch, and that's what makes us special.",
  },
  {
    id: "2",
    imgsSrc:
      `${S3_BASE_URL}/friendly-advisors.webp`,
    heading: "Friendly Advisors",
    description:
      "Beyond our core team, we have some friendly advisors who are well-connected in the industry. They're like our guiding stars, bringing industry wisdom and networks to the table.",
  },
  ,
  {
    id: "3",
    imgsSrc:
      "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709113147.svg",
    heading: "Dreamers of Big Dreams",
    description:
      "We all share a common dream – to shake things up and make the chemical industry more exciting and efficient. It's this dream that keeps us going, day in and day out.",
  },
  {
    id: "4",
    imgsSrc:
      "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709113179.svg",
    heading: "Tech and Innovation Lovers",
    description:
      "We're a bunch of tech enthusiasts and forward-thinkers. We love exploring new ideas and technologies, and that's the spark behind our innovative solutions.",
  },
  {
    id: "5",
    imgsSrc:
      "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709113227.svg",
    heading: "Common Value System",
    description:
      "Our journey is anchored in some simple yet important values. They're like our North Star, helping us build strong relationships, work together seamlessly, and strive for excellence.",
  },
  {
    id: "6",
    imgsSrc:
      `${S3_BASE_URL}/multigenerational-team.webp`,
    heading: "Entrepreneurs At Heart",
    description:
      "We all are Entrepreneurs at heart! Our designations, team names and Job descriptions are just on paper. If it's a part of our Mission, we are all on it!",
  },
];
const Frequentlyquestions = [
  {
    id: "1",
    name: "How do I apply for a job at Elchemy?",

    description: (
      <p>
        Apply to our Open roles on our{" "}
        <span>
          <a
            href={JOB_LISTING_LINK}
            className="text-decoration: underline text-[#3366CC]"
            rel="noopener noreferrer"
          >
            Careers Page
          </a>{" "}
          OR email your resume on{" "}
          <a
            href="mailto:hr@elchemy.com"
            className="text-decoration: underline text-[#3366CC]"
            rel="noopener noreferrer"
          >
            {" "}
            hr@elchemy.com{" "}
          </a>
        </span>
        . Don't forget to showcase your awesome self by providing detailed
        information and answering any specific job-related questions.
      </p>
    ),
  },
  {
    id: "2",
    name: "How long does the hiring process take?",
    description:
      "The timeline varies based on factors like your availability, assignment submission speed, and location. On average, we aim to go from application to offer in a month. But hey, we're not shy to mention that our record is an impressive 6 days! 🏆",
  },
  {
    id: "3",
    name: "What should I wear for interviews?",
    description:
      "Whatever makes you feel fantastic! At Elchemy, we don't have a dress code—whether it's for interviews or your daily grind. ",
  },
  {
    id: "4",
    name: "I need to travel to a different location for the in-person Interview. Are costs covered?",
    description: "Yes, we have our in-person Interviews in our Mumbai office",
  },
];
const steps = [
  {
    label: "Process 1",
    heading: "What's Expected of You:",
    application: "Application (1 to 2 days)",
    heading1: "Behind the Scenes",
    description: (
      <p>
        Send in your CV to{" "}
        <span>
          Send your resume to{" "}
          <a
            href="mailto:hr@elchemy.com"
            rel="noopener noreferrer"
            className="text-decoration: underline text-[#3366CC]"
          >
            {" "}
            hr@elchemy.com{" "}
          </a>
          or{""}
          <a
            href="/contact-elchemy"
            rel="noopener noreferrer"
            className="text-decoration: underline text-[#3366CC]"
          >
            {" "}
            Contact Us{" "}
          </a>
        </span>{" "}
        here and a compelling cover letter. Feel free to provide additional
        information such as your LinkedIn and GitHub profiles, academic
        background, and more. The more details you share, the faster and more
        informed our decision-making process becomes.
      </p>
    ),
    desciption1:
      "Your application once received is reviewed and if it seems like a good fit, We aim to respond within 24 hours, though it might take up to 48 hours on occasion for the next stage",
  },
  {
    label: "Process 2",
    heading: "What's Expected of You:",
    application: "Phone Call (~1 week)",
    heading1: "Behind the Scenes",
    description:
      "Congratulations on passing the application stage! A team member will engage in a non-technical chat to explore your motivations, experiences, personality, and practical details.",
    desciption1:
      "Before the call, your Recruiter performs a quick profile check for any anomalies in your CV, makes a note of clarifying questions to be asked during the call.",
  },
  {
    label: "Process 3",
    heading: "Interview:",
    application: "Interview Round 1 & Assessment (1 to 2 weeks)",
    heading1: "Behind the Scenes",
    heading2: "Assignment:",
    heading3: "Behind the Scenes",
    description: `What's Expected of You: Be prepared to share more about your journey, motivations and ask questions during the roughly 30-40 min interview where we gauge a mutual fitness between you and the company. `,
    desciption1:
      "Post-interview, feedback is shared with the Hiring team, who then decides on moving on to the next step if all seems good",
    description2:
      "What's Expected of You: Following a successful initial round, you'll receive an assignment tailored to the position.",
    description3:
      "The team members independently review your assignment. Their feedback guides the decision to invite you to the Office for an In-person Interview.",
  },
  {
    label: "Process 4",
    heading: "What's Expected of You:",
    application: "On-site Visit (1 day)",
    heading1: "Behind the Scenes",
    description: `Meet various team members, engage in detailed conversations, and simply be yourself. `,
    desciption1:
      "Your recruiter orchestrates the day, gathering feedback and facilitating a final decision meeting.",
  },
  {
    label: "Process 5",
    heading: "What's Expected of You:",
    application: "Reference Checks and Offer!",
    heading1: "Behind the Scenes",
    description: `If all goes well, You will receive an offer once the Reference checks are successfully completed, and the People Team will guide you through a smooth transition. At Elchemy, your journey isn't just a series of steps; it's a personalised adventure. We understand that each candidate is unique, and our process reflects our commitment to ensuring a perfect fit for both you and us. Get ready to embark on a career experience that goes beyond expectations.`,
    desciption1:
      "We will have conversations with people who have worked with you in the past and shall inform you once these conversations are completed. If all goes well, you shall receive an Offer Letter email from us.",
  },
];

const Careers = () => {
  const [expanded, setExpanded] = useState(null);
  const [activeStep, setActiveStep] = React.useState(0);
  const handleMouseEnter = (index) => {
    setHoverStates((prevStates) => {
      const newStates = [...prevStates];
      newStates[index] = true;
      return newStates;
    });
  };

  const [hoverStates, setHoverStates] = useState(
    Array(contentimage.length).fill(false)
  );
  const handleMouseLeave = (index) => {
    setHoverStates((prevStates) => {
      const newStates = [...prevStates];
      newStates[index] = false;
      return newStates;
    });
  };

  const handleStepClick = (index) => () => {
    setActiveStep(index);
  };

  const getIcon = (index) => {
    return (
      <>
        <div
          className={`w-[3rem] h-[3rem] flex justify-center  cursor-pointer align-center rounded-[100%] ${
            activeStep === index ? " bg-red" : "bg-[#EF41361A]"
          }`}
        >
          {activeStep === index ? (
            <img
              src="https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112449.svg"
              alt="page Icon "
              className="w-[1rem]"
            />
          ) : (
            <img
              src="https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709112449.svg"
              alt="page Icon ligt"
              className="w-[1rem] "
            />
          )}
        </div>
      </>
    );
  };
  return (
    <div className="overflow-hidden ">
      <MetaTags
        title="Elchemy Is A Catalyst For Your Professional Growth And Personal Success In The Chemical Industry"
        desciption="Fuel your career in the chemical industry with Elchemy. Join our innovative team for opportunities in chemical sales, chemical sourcing, supply chain, operations, technology, and more. Make a mark in the chemical universe."
      />
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: "Home",
            item: `${process.env.NEXT_PUBLIC_APP_URL}/`,
          },
          {
            position: 2,
            name: "Careers",
            item: `${process.env.NEXT_PUBLIC_APP_URL}/careers`,
          },
        ]}
      />

      <div>
        <section>
          <div className="w-full bg-[#00000024] relative">
            <img
              src={`${S3_BASE_URL}/products/icons/1709277849.webp`}
              className="w-full h-full object-cover"
              style={{ height: "540px" }}
              alt="Careers page Background "
            />
            <div className="absolute top-0 w-full h-[540px] mt-[-5rem] md:mt-[0] flex justify-center items-center z-10 ">
              <p className="absolute top-[14vh] md:top-[10vh] left-4 sm:left-20 ">
                <Link
                  href={"/"}
                  className=" font-normal text-[14px] text-[#dfdfdf]"
                >
                  Home
                </Link>{" "}
                <span className="px-1 text-white">/</span>{" "}
                <span className="font-normal text-[14px] text-white ">
                  Careers
                </span>
              </p>
              <div className="flex flex-col justify-center  mt-[6rem] md:mt-[0] items-center pt-20">
                <h1 className="text-[#FFFFFF] text-[20px] md:text-[40px]  w-[70%] text-center p-1 px-4 font-mukta ">
                  Embrace the Challenge of Reimagining the Chemical Industry by
                  Joining Us
                </h1>
                <div className="flex gap-4">
                  <a
                    href="https://tally.so/r/3xJz4v"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="pt-6 flex gap-4">
                      <div className="py-2 px-6  md:px-10 flex items-center justify-center text-[1rem] md:text-[1.4rem] font-mukta font-[500] bg-red  text-[#fff] rounded-[3px]">
                        Join Us
                      </div>
                    </div>
                  </a>
                  <a
                    href={JOB_LISTING_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="pt-6 flex gap-4">
                      <div className="py-2 px-6  md:px-10 flex items-center justify-center text-[1rem] md:text-[1.4rem] font-mukta font-[500] bg-white  text-[#ef4136] rounded-[3px]">
                        View open roles
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="px-[2rem] sm:px-[4.4rem] md:px-[6.75rem]">
          <section>
            <CareerCard />
          </section>
          <section>
            <AbsoluteSkewebar text={"Elchemy's Career Exploration Journey"} />

            <div className="w-full mt-4 md:mt-[2rem] flex flex-col gap-8 font-normal text-[#666666] ">
              <p>
                At Elchemy, our hiring experience is meticulously designed to be
                both efficient and thorough. We believe that everyone involved
                should be 100% sure of the decisions they make, ensuring a
                seamless transition into a team where you'll thrive and
                contribute your best. Here's a glimpse into the Elchemy Hiring
                Adventure:
              </p>
              <div className="">
                <Box>
                  <Stepper
                    className=" "
                    activeStep={activeStep}
                    orientation="vertical"
                    elevation={0}
                  >
                    {steps.map((step, index) => (
                      <Step key={step.label}>
                        <StepLabel
                          className="w-fit cursor-pointer"
                          onClick={handleStepClick(index)}
                          StepIconComponent={() => getIcon(index)}
                        >
                          <div className="ml-[2px] cursor-pointer">
                            <div className=" font-mukta font-normal text-[16px] text-[#666666]">
                              {step.label}
                              <h2 className="text-[#161616] mt-[4px] font-mukta font-normal text-[24px]">
                                {step.application}
                              </h2>
                            </div>
                          </div>
                        </StepLabel>

                        <div className=" flex flex-col md:gap-4 font-mukta font-normal text-[24px]">
                          <div className="">
                            <StepContent>
                              <Stack
                                direction={{ xs: "column", md: "row" }}
                                gap={"2rem"}
                              >
                                <div className="lg:w-1/2 mt-4 ">
                                  <p className=" ml-[1.4rem] font-medium text-[14px] text-[#161616]">
                                    {step.heading}
                                  </p>
                                  <p className=" w-[90%]  lg:w-[100%%] ml-[1.4rem] mt-[1rem] text-[16px] font-normal text-[#666666]">
                                    {step.description}
                                  </p>
                                  <p className=" ml-[1.4rem] lg:mt-[2rem] font-medium text-[14px] text-[#161616]">
                                    {step.heading2}
                                  </p>
                                  <p className=" w-[90%]  lg:w-[100%%] ml-[1.4rem] mt-[1rem] text-[16px] font-normal text-[#666666]">
                                    {step.description2}
                                  </p>
                                </div>

                                <div
                                  className=" md:w-1/2    ml-[1.8rem] md:mt-[0] lg:ml-[0] mb-[3rem]"
                                  style={{
                                    marginTop: "1rem",
                                  }}
                                >
                                  <p className="font-medium text-[14px] text-[#161616]">
                                    {step.heading1}
                                  </p>
                                  <p className="text-[16px]  w-[90%] lg:w-[80%] mt-[1rem]  font-normal text-[#666666]">
                                    {step.desciption1}
                                  </p>
                                  <p className="font-medium mt-[2rem] text-[14px] text-[#161616]">
                                    {step.heading3}
                                  </p>
                                  <p className="text-[16px]  w-[90%] lg:w-[80%] mt-[1rem]  font-normal text-[#666666]">
                                    {step.description3}
                                  </p>
                                </div>
                              </Stack>
                            </StepContent>
                          </div>
                        </div>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              </div>
            </div>
          </section>
          <section>
            <Expertise />
          </section>
          <div className="flex text-3xl ">
            <AbsoluteSkewebar text={"Elchemy Expertise"} />
          </div>

          <div className=" md:mt-[2rem] flex md:h-[42rem] flex-wrap md:gap-8">
            <Grid container spacing={2}>
              {contentimage.map((data, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <div
                    key={index}
                    className="focus:outline-none flex flex-col items-start  md:h-[20rem]"
                  >
                    <div
                      key={index}
                      className="focus:outline-none flex flex-col items-start md:h-[20rem]"
                    >
                      <div
                        className="relative overflow-hidden fastFadeOut"
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={() => handleMouseLeave(index)}
                        key={index}
                      >
                        <Image
                          src={data.imgsSrc}
                          alt={data.name}
                          className="w-full h-[250px] md:w-[416px] md:h-[199px] object-cover"
                          width={416}
                          height={200}
                        />
                        <div
                          className={`absolute w-[20%] md:ml-[2rem]  md:h-[13rem] top-0  whatWeDoBar ${
                            hoverStates[index] ? " left-[120%]" : "left-[-60%]"
                          } bg-[#ef4136] transition-all duration-1000`}
                          key={index}
                        ></div>
                      </div>
                      <h2 className="text-[20px]  font-mukta md:mt-4">
                        {data.heading}
                      </h2>
                      <div className="text-[14px]  w-[95%] text-[#666] mt-0.3 ">
                        {hoverStates[index] ? data?.description : ""}
                      </div>
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>
          </div>
          <section>
            <div className="flex  md:pt-20 text-3xl mt-10">
              <AbsoluteSkewebar text={"Frequently Asked Questions (FAQs)"} />
            </div>
            <div className=" w-full h-full md:px-24 mb-32 mt-4 sm:mt-16 ">
              {Frequentlyquestions?.map((items, index) => {
                return (
                  <>
                    <div className="mt-8  w-[100%] overflow-hidden">
                      <Accordion elevation={0}>
                        <AccordionSummary
                          key={index}
                          expandIcon={
                            index !== expanded ? <AddIcon /> : <RemoveIcon />
                          }
                          onClick={(event) => {
                            setExpanded(index !== expanded ? index : null);
                          }}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          sx={{
                            border: "none",
                          }}
                        >
                          <h2 className="text-[16px]  text-[#161616] font-medium">
                            {items?.name}
                          </h2>
                        </AccordionSummary>
                        <AccordionDetails>
                          <p className="font-normal  text-[#4D4D4D] text-[14px]">
                            {items?.description}
                          </p>
                        </AccordionDetails>
                      </Accordion>
                      <hr></hr>
                    </div>
                  </>
                );
              })}
            </div>
            <div className="">
              <WorkingWithUs />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Careers;
